// storageExpire.js
const StorageExpire = {
  /**
   * 设置 localStorage（可选设置有效期）
   * @param {String} key
   * @param {Any} value
   * @param {Number|null} expireSeconds 过期时间（秒），默认 null = 永不过期
   */
  set(key, value, expireSeconds = null) {
    const data = {
      value,
      expire: expireSeconds ? Date.now() + expireSeconds * 1000 : null
    };
    localStorage.setItem(key, JSON.stringify(data));
  },

  /**
   * 获取值（自动处理过期）
   */
  get(key) {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
      const data = JSON.parse(item);

      // 永不过期
      if (!data.expire) return data.value;

      // 已过期
      if (Date.now() > data.expire) {
        localStorage.removeItem(key);
        return null;
      }

      return data.value;
    } catch (e) {
      // 数据不规范
      return null;
    }
  },

  /**
   * 删除某个 key
   */
  remove(key) {
    localStorage.removeItem(key);
  },

  /**
   * 清空所有 localStorage
   */
  clear() {
    localStorage.clear();
  }
};

export default StorageExpire;



// WEBPACK FOOTER //
// ./src/common/storageExpire.js